<template>
    <v-layout class="mt-3 px-10">
      <v-form
        ref="form"
        v-model="valid"
      >
        <!-- <v-text-field
      label="Name"
      v-model="name"
      :rules="nameRules"
      :counter="10"
      required
    ></v-text-field> -->
        <!-- <v-text-field
      label="E-mail"
      v-model="email"
      :rules="emailRules"
      required
    ></v-text-field> -->
        <v-text-field
          v-model="senhaAtual"
          :append-icon="show1 ? 'visibility' : 'visibility_off'"
          :rules="senhaRules"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          label="Senha atual"
          counter
          @click:append="show1 = !show1"
        />
        <v-text-field
          v-model="novaSenha"
          :append-icon="show2 ? 'visibility' : 'visibility_off'"
          :rules="senhaRules"
          :type="show2 ? 'text' : 'password'"
          name="input-10-1"
          label="Nova senha"
          counter
          @click:append="show2 = !show2"
        />

        <v-checkbox
          v-model="checkbox"
          label="Você concorda?"
          :rules="[(v) => !!v || 'Você deve concordar para alterar']"
          required
        />
        <v-alert
          :value="erroSenhaAntigaInvalida"
          color="error"
          icon="warning"
          outlined
        >
          Senha atual incorreta!!
        </v-alert>
        <v-alert
          :value="erroEditar"
          color="error"
          icon="warning"
          outlined
        >
          Erro ao editar senha !!
        </v-alert>

        <v-alert
          :value="sucessoEditar"
          color="success"
          icon="check_circle"
          outlined
        >
          Sucesso ao editar senha !!
        </v-alert>
        <v-card-actions>
          <v-spacer/>
        <v-btn
          dark
          :class="{ red: !valid, green: valid }"
          @click="submit"
        >
          Salvar
        </v-btn>
        <v-btn @click="$router.go(-1)">
          <v-icon left>
            keyboard_backspace
          </v-icon>
          voltar
        </v-btn>
      </v-card-actions>
      </v-form>
    </v-layout>

</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'EditarAdministrador',
  data () {
    return {
      senhaAtual: '',
      erroEditar: false,
      sucessoEditar: false,
      erroSenhaAntigaInvalida: false,
      erroAlterarSenha: 'false',
      novaSenha: '',
      show1: false,
      show2: false,
      valid: false,
      name: 'Default',
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => v && v.length <= 10 || 'Name must be less than 10 characters'
      ],
      senhaRules: [
        (v) => v && v.length > 5 || 'senha deve ter mais de 5 caracteres'
      ],
      email: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: false
    }
  },

  mounted () {
    this.user = this.$store.getters.usuario
  },
  methods: {
    submit () {
      this.$refs.form.validate()
      if (this.$refs.form.validate()) {
        console.log('for editar adm..')
        console.log(this.user)
        this.erroEditar = false
        this.erroSenhaAntigaInvalida = false
        this.erroAlterarSenha = false

        administradorUnidadeService.administradorUnidade
          .alterarSenhaAdministrador(this.senhaAtual, this.novaSenha, this.user.tipo, this.user.username)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)
            if (rsp.data == 'erro') {
              this.erroEditar = true
            }
            if (rsp.data == 'senhaAntigaInvalida') {
              this.erroSenhaAntigaInvalida = true
            }
            if (rsp.data == true) {
              this.sucessoEditar = true
              this.clear()
            }
          })
          .catch(err => {
          // handle your error here
            console.log(err)
          })
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }

}

</script>
